<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre_13"><span class="calibre5"><a></a><em class="italic">Living</em></span></p>
<p class="calibre_5"><span class="calibre5"><em class="italic">Should Be<br class="calibre1"/>Perpetual and Universal<br class="calibre1"/>Benediction.</em></span></p><div class="calibre_14"> </div> <div class="mbp_pagebreak" id="calibre_pb_6"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_005.vue?77366e17